<template>
  <div class="faq-wrap">
    <span class="title">{{ $t('newblock.helpPage.faq.title') }}</span>
    <div class="content-wrap" :class="{'not-mobile': !mobile}">
      <div class="left-content">
        <div v-for="(item,i) in $t('newblock.helpPage.faq.questions')" :key='i'>
          <span class="subtitle">{{ item.title }}</span>
          <span class="text">
            {{ item.answer }}
          </span>
        </div>
      </div>
    </div>
    <div class="filler" v-if="mobile">1</div>
  </div>
</template>

<script>
export default {
  props:{
    mobile: Boolean
  }
};
</script>

<style lang="scss" scoped>
@mixin title { 
  width: 100%;
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 10px;
  display: block;
}
@mixin subtitle { 
  display: block;
  margin: 20px 0;
  font-size: 16px;
  font-weight: 600;
}
@mixin text { 

}
.faq-wrap {
  padding: 20px;
  .content-wrap {
    &.not-mobile {
      // text-align: center;
      display: block;
      .left-content {
        padding-right: 20px;
        width: calc(50% - 10px);
        margin: 0 auto;
        div {
          margin: 0 auto;
        }
      }
      .right-content {
        width: calc(50% - 10px);
      }
    }
  }

  .filler {
    height: 65px;
    line-height: 65px;
    color: transparent;
  }
  .title {
    @include title();
    text-align: center;
  }
  .left-content {
    .subtitle {
      text-align: left;
      @include subtitle();
    }
    .text {
      text-align: left;
      @include text();
    }
  }
  .right-content {
    .subtitle {
      @include subtitle();
    }
    .text {
      @include text();
    }
  }
}
</style>